import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface MassRoadmapService {
  markAsIncludedToRoadmap: (ids: number[]) => Promise<void>,
}

export const TASKS_MASS_ROADMAP_UPDATED = 'TASKS_MASS_ROADMAP_UPDATED';

export interface TasksMassRoadmapUpdatedEvent {
  ids: number[],
}

export function useProjectTasksMassRoadmapService(): MassRoadmapService {
  const projectsApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const markAsIncludedToRoadmap = async (ids: number[]) => {
    await projectsApi.put('/tasks/bulk/roadmap', {
      ids,
    });

    eventsPublisher.publish<TasksMassRoadmapUpdatedEvent>(TASKS_MASS_ROADMAP_UPDATED, {
      ids,
    });
  };

  return {
    markAsIncludedToRoadmap,
  };
}
